import { render, staticRenderFns } from "./Temas.vue?vue&type=template&id=464348a0&scoped=true"
import script from "./Temas.vue?vue&type=script&lang=js"
export * from "./Temas.vue?vue&type=script&lang=js"
import style0 from "./Temas.vue?vue&type=style&index=0&id=464348a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464348a0",
  null
  
)

export default component.exports